import request from '@/utils/request'
// 获取个人资料
export function getSelfInfo () {
  return request({
    url: '/hr/userextatt/selfInfo',
    method: 'GET'
  })
}
// 个人资料修改
export function updateUser (data) {
  return request({
    url: '/hr/userextatt/update',
    method: 'POST',
    data
  })
}
// 密码修改
export function updatePassword (data) {
  return request({
    url: '/sys/user/password',
    method: 'POST',
    data
  })
}
// 获取接包发包角色
export function getUsercrowd () {
  return request({
    url: '/hr/usercrowdpermission/self',
    method: 'GET'
  })
}
// 微信解绑
export function unbindWechat () {
  return request({
    url: '/wx/unbind',
    method: 'POST',
  })
}
// 获取微信绑定状态
export function getBindStatus () {
  return request({
    url: '/wx/getBindStatus',
    method: 'GET'
  })
}
// 绑定手机号
export function mobileBind (data) {
  return request({
    url: '/hr/userextatt/bindMobilePhone',
    method: 'POST',
    data
  })
}
// 绑定邮箱
export function emailBind (data) {
  return request({
    url: '/hr/userextatt/bindEmail',
    method: 'POST',
    data
  })
}
// 获取手机号验证码
export function mobileCode (data) {
  return request({
    url: '/sys/sms/sendVerificationCode',
    method: 'POST',
    data
  })
}
// 获取邮箱验证码
export function emailCode (data) {
  return request({
    url: '/sys/mailtemplate/sendVerificationCode',
    method: 'POST',
    data
  })
}

// 切换接包发包角色
export function updateUsercrowd (data) {
  return request({
    url: '/hr/usercrowdpermission/update',
    method: 'POST',
    data
  })
}
// 获取认证状态
export function getUsercerf () {
  return request({
    url: '/hr/userextatt/cerf',
    method: 'GET'
  })
}
// 获取认证状态字典
export function getCerfStatus () {
  return request({
    url: '/sys/dict/type/all/certification_status',
    method: 'GET'
  })
}
// 提交认证资料 type 0 个人认证，type 1 公司认证
export function certapply (data) {
  return request({
    url: '/hr/certapply',
    method: 'POST',
    data
  })
}
// 案例添加
export function addUsercase (data) {
  return request({
    url: '/hr/usercase',
    method: 'POST',
    data
  })
}
// 案例修改
export function updateUsercase (data) {
  return request({
    url: '/hr/usercase/update',
    method: 'POST',
    data
  })
}
// 案例删除
export function deleteUsercase (data) {
  return request({
    url: '/hr/usercase/delete',
    method: 'POST',
    data
  })
}
// 案例查询
export function getUsercase (params) {
  return request({
    url: '/hr/usercase/fetch',
    method: 'GET',
    params
  })
}